export function renderMarkdown(md: string): string {
  return md
    .replace(/^# (.+)$/gm, '<h1 style="font-size:24px;font-weight:700;margin:0 0 16px;color:#141414">$1</h1>')
    .replace(/^## (.+)$/gm, '<h2 style="font-size:18px;font-weight:600;margin:24px 0 12px;color:#262626">$1</h2>')
    .replace(/^### (.+)$/gm, '<h3 style="font-size:15px;font-weight:600;margin:20px 0 8px;color:#434343">$1</h3>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/`(.+?)`/g, '<code style="background:#f5f5f5;padding:2px 5px;border-radius:3px;font-size:12px">$1</code>')
    .replace(/^---$/gm, '<hr style="border:none;border-top:1px solid #f0f0f0;margin:20px 0"/>')
    .replace(/^\| (.+) \|$/gm, (match) => {
      const cells = match.split('|').filter((c) => c.trim());
      return '<tr>' + cells.map((c) => `<td style="padding:8px 12px;border:1px solid #f0f0f0">${c.trim()}</td>`).join('') + '</tr>';
    })
    .replace(/(<tr>[\s\S]*?<\/tr>)/g, '<table style="border-collapse:collapse;width:100%;margin:12px 0">$1</table>')
    .replace(/^- (.+)$/gm, '<li style="margin:4px 0">$1</li>')
    .replace(/(<li[^>]*>[\s\S]*?<\/li>)/g, '<ul style="padding-left:20px;margin:8px 0">$1</ul>')
    .replace(/^\d+\. (.+)$/gm, '<li style="margin:4px 0">$1</li>')
    .replace(/\n\n/g, '<br/><br/>')
    .replace(/\n/g, '<br/>');
}
